module.exports = __webpack_public_path__ + "img/OnlineEvent.520420aa.svg";